module.exports = __webpack_public_path__ + "img/ersterMaiskolben.d833d028.svg";